import {
  ButtonModule,
  GridModule,
  PaddingModule,
  SpacingModule,
  VideoModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TwoColBlockComponent } from './two-col-block.component';
import { AvatarBlockModule } from '../avatar-block/avatar-block.module';
import { ButtonsBlockModule } from '../buttons-block/buttons-block.module';
import { BlockQuoteBlockModule } from '../blockquote-block/blockquote-block.module';
import { ImageBlockModule } from '../image-block/image-block.module';
import { TextBlockModule } from '../text-block/text-block.module';
import { TitleBlockModule } from '../title-block/title-block.module';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@shared/pipes/pipes.module';
import { TableSelectionModule } from '@marketing/table-selection/table-selection.module';
import { BlockQuoteAvatarBlockModule } from '../blockquote-avatar-block/blockquote-avatar-block.module';
import { MediaCardBlockModule } from '@marketing/content-blocks/media-card-block/media-card-block.module';
import { InteractiveContentBlockModule } from '../interactive-content-block/interactive-content-block.module';
import { DividerCompModule } from '@shared/divider/divider.module';

@NgModule({
  declarations: [TwoColBlockComponent],
  imports: [
    AvatarBlockModule,
    BlockQuoteBlockModule,
    ButtonsBlockModule,
    ImageBlockModule,
    TextBlockModule,
    TitleBlockModule,
    BrSdkModule,
    CommonModule,
    RouterModule,
    GridModule,
    PaddingModule,
    SpacingModule,
    PipesModule,
    VideoModule,
    TableSelectionModule,
    BlockQuoteAvatarBlockModule,
    MediaCardBlockModule,
    InteractiveContentBlockModule,
    DividerCompModule,
  ],
  exports: [TwoColBlockComponent],
  entryComponents: [TwoColBlockComponent],
})

/**
 * Image Block Module
 */
export class TwoColBlockModule {}
